import React, { useState, useEffect, useRef } from "react";
import ChatSessionService from "services/chat-session.service";
import AuthService from "services/auth.service";
import IconFoodLog from "assets/icons/food-log-icon.svg";
import IconArrowDown from "assets/icons/expandAllIcon.svg";
import PreviousBtn from "assets/icons/Previous.svg";
import NextBtn from "assets/icons/Next.svg";
import FoodLogModal from "./FoodLogModal";
import { Accordion, Card, Button } from "react-bootstrap";
import moment from "moment";
import Spinner from "react-bootstrap/Spinner";

function AccordianFoodLog({ chat }) {
  const isCancelled = useRef(false);
  const [foodLog, setFoodLog] = useState([]);
  const [meta, setMeta] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getFoodLogList(1);
    return () => {
      isCancelled.current = true;
    };
  }, []); // eslint-disable-line

  const handlePageChange = (i) => {
    setLoading(true);
    let newPage = meta.current_page + i;
    if (newPage > 0 && newPage <= meta.total_pages) {
      getFoodLogList(newPage);
    }
    setLoading(false);
  };

  const getFoodLogList = (current_page) => {
    setLoading(true);
    var params = {
      page: current_page,
    };
    ChatSessionService.getFoodLogList(chat.id, params).then(
      (res) => {
        setFoodLog(res.food_log);
        setMeta(res.meta);
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace("/eb/login");
        }
      }
    );
    setLoading(false);
  };

  return (
    <>
      <Card className="food-log-info card-accordian">
        <Card.Header>
          <Accordion.Toggle as={Button} variant="link" eventKey="3">
            <div className="header-title">
              <img
                src={IconFoodLog}
                alt="icon-food-log"
                className="title-icon"
              />
              <div className="title">
                Food Log
                <span className="badge badge-warning meal-count">
                  {meta.total_meals}
                </span>
              </div>
            </div>
            <div>
              <img src={IconArrowDown} alt="icon-arrow-down" />
            </div>
          </Accordion.Toggle>
        </Card.Header>
        <Accordion.Collapse eventKey="3">
          <Card.Body>
            {loading ? (
              <div className="loader">
                <Spinner animation="border" className="spinner" />
              </div>
            ) : (
              <>
                {foodLog.map((q, i) => (
                  <div className="container" key={`food-log-${i}`}>
                    <img
                      src={q.image}
                      className="container__image"
                      alt="food-img"
                    />
                    <div className="container__text">
                      <div className="food-log-row">
                        <FoodLogModal
                          props={q}
                          gender={chat.user_info.sex}
                          user_id={chat.user_info.id}
                          type="teleconsult"
                        ></FoodLogModal>
                        <div className="food-log-details">
                          <div className="comment">
                            {q.comment_count} comments
                          </div>
                          <p className="date">
                            {moment(q.date).format("DD MMM")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}

            <div className="pagination">
              <button className="btn btn-link">
                <img
                  src={PreviousBtn}
                  alt="previous"
                  className="page-prev-btn"
                  onClick={() => handlePageChange(-1)}
                />
              </button>

              <b className="font-size-4 px-1 count">
                {meta.current_page} of {meta.total_pages}
              </b>

              <button className="btn btn-link">
                <img
                  src={NextBtn}
                  alt="next"
                  className="page-next-btn"
                  onClick={() => handlePageChange(1)}
                />
              </button>
            </div>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </>
  );
}

export default AccordianFoodLog;
